/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { type FieldValues, type Path, type UseFormSetError } from "react-hook-form";

interface FastApiValidationMsg {
  type: string;
  loc: string[];
  msg: string;
  input: string;

  ctx: any;
}

export const useReactHookFormAxiosValidation = <U extends FieldValues>() =>
  React.useCallback((error: any, setError: UseFormSetError<U>) => {
    const errorList = ((error.response || error)?.data?.detail || []) as FastApiValidationMsg[];

    errorList.forEach(error => {
      const name = error.loc.slice(1).join(".") as Path<U>;
      setError(name, {
        type: "server",
        message: error.msg,
      });
    });
  }, []);
